import { Col, Form, InputNumber, Row } from 'antd';

interface LocationGeoFieldsProps {
  /** En edición las coordenadas son opcionales (PATCH parcial); en el alta son requeridas. */
  isEdit: boolean;
}

/**
 * Paso 3 del alta de Locación: geolocalización (lat/long). Reusado por el modal de edición.
 * El mapa (`LocationMapPicker`) lo monta el host por encima de estos inputs.
 */
export function LocationGeoFields({ isEdit }: LocationGeoFieldsProps) {
  return (
    <Row gutter={16}>
      <Col span={12}>
        <Form.Item
          label="Latitud"
          name="latitude"
          rules={[
            { required: !isEdit, message: 'Ingresa la latitud.' },
            {
              type: 'number',
              min: -90,
              max: 90,
              message: 'La latitud debe estar entre -90 y 90.',
            },
          ]}
        >
          <InputNumber
            min={-90}
            max={90}
            step={0.00001}
            precision={5}
            style={{ width: '100%' }}
            placeholder="4.676"
          />
        </Form.Item>
      </Col>

      <Col span={12}>
        <Form.Item
          label="Longitud"
          name="longitude"
          rules={[
            { required: !isEdit, message: 'Ingresa la longitud.' },
            {
              type: 'number',
              min: -180,
              max: 180,
              message: 'La longitud debe estar entre -180 y 180.',
            },
          ]}
        >
          <InputNumber
            min={-180}
            max={180}
            step={0.00001}
            precision={5}
            style={{ width: '100%' }}
            placeholder="-74.048"
          />
        </Form.Item>
      </Col>
    </Row>
  );
}
